import { SITE } from '~/content/site.js';

interface PageMetaProps {
  title: string;
  description: string;
  /** Path from the site root, e.g. `/jobs/senior-product-engineer`. */
  path: string;
  /** Draft previews and error pages should stay out of the index. */
  noIndex?: boolean;
  jsonLd?: string;
}

/**
 * React 19 hoists `title`, `meta` and `link` into the document head, so page
 * metadata is declared where the page is rendered rather than in a side effect.
 */
export function PageMeta({ title, description, path, noIndex, jsonLd }: PageMetaProps) {
  const canonical = SITE.careersUrl + path;
  const fullTitle = title === SITE.defaultTitle ? title : title + ' — ' + SITE.companyName + ' Careers';

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noIndex ? <meta name="robots" content="noindex, nofollow" /> : null}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.companyName + ' Careers'} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      {jsonLd ? <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLd }} /> : null}
    </>
  );
}
